@if (config()?.text; as text) {
  <div class="text" role="text" [attr.aria-label]="config()?.ariaLabel">{{ text }}</div>
}
